import script from "./PostItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./PostItem.vue?vue&type=script&lang=ts&setup=true"

import "./PostItem.vue?vue&type=style&index=0&id=7633b7fe&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/posuto/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7633b7fe"]])

export default __exports__